<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: 'DouYinReleaseRecord',
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      },{
        name: 'title',
        placeholder: '标题',
        type: 'input'
      }],
      permission: {
        add: 'douYinReleaseRecord:add',
        update: 'douYinReleaseRecord:update',
        delete: 'douYinReleaseRecord:delete',
        deleteBatch: 'douYinReleaseRecord:deleteBatch'
      },
      url: {
        get: '/douYinReleaseRecord/listByCondition',
        add: '/douYinReleaseRecord/add',
        update: '/douYinReleaseRecord/update',
        delete: '/douYinReleaseRecord/delete',
        delete_batch: '/douYinReleaseRecord/deleteBatch',
        status: '/douYinReleaseRecord/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      },
        {
          field: 'agentId',
          label: '代理',
          selectUrl: '/agent/getAll',
          selectData: [],
          show: {
            type: 'select',
          },
          width: '',
        }, {
          field: 'title',  // 字段名
          label: '标题',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'tags',  // 字段名
          label: '标签',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'productLink',  // 字段名
          label: '商品链接',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'publishTime',  // 字段名
          label: '发布时间',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        },
        {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        }
      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            isEdit: true
          },
          {
            field: 'agentId',
            label: '代理：',
            type: 'select',
            placeholder: '请选择代理',
            rules: [{required: true, message: '请选择代理', trigger: 'blur'}],
            selectUrl: '/agent/getAll',
            selectData: [],
            add: true,
            update: true,
            filterable: true,
          }, {
            field: 'title',  // 字段名
            label: '标题',  // 字段显示名称
            type: 'input',
            placeholder: '请输入标题',
            rules: [
              {required: true, message: '标题不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'tags',  // 字段名
            label: '标签',  // 字段显示名称
            type: 'input',
            placeholder: '请输入标签',
            rules: [
              {required: true, message: '标签不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'productLink',  // 字段名
            label: '商品链接',  // 字段显示名称
            type: 'input',
            placeholder: '请输入商品链接',
            rules: [
              {required: true, message: '商品链接不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'publishTime',  // 字段名
            label: '发布时间',  // 字段显示名称
            type: 'dateTime',
            placeholder: '请选择发布时间',
            rules: [
              {required: true, message: '发布时间不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          },
        ]
      },
      operate: []
    }
  }
}
</script>

<style scoped>

</style>
